module.exports = __webpack_public_path__ + "img/money-primary.2824aea.png";